var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgZec = function SvgZec(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#F5A623",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6117 34.505H37.5441V39.9713H31.0937V44.5964H25.4841V40.1146H18.7566C18.7566 38.2893 18.4795 36.4736 18.8999 34.7918C19.0432 33.9508 20.018 33.1098 20.725 32.269C22.8275 29.7461 24.9299 27.2233 27.1756 24.7005C28.0164 23.7162 28.8575 22.8752 29.8418 21.7572H19.33V16.291H25.4936V11.6665H30.9599V16.1471H37.6874C37.6874 17.9722 37.9645 19.788 37.5441 21.4698C37.4008 22.3108 36.426 23.1517 35.7188 23.9927C33.6165 26.5155 31.5141 29.0383 29.2684 31.5612C28.4272 32.5461 27.5865 33.5207 26.6117 34.505Z",
    fill: "#F5A623"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.4167C12.8582 55.4167 0.583333 43.1418 0.583333 28H-0.583333C-0.583333 43.7861 12.2139 56.5833 28 56.5833V55.4167ZM55.4167 28C55.4167 43.1418 43.1418 55.4167 28 55.4167V56.5833C43.7861 56.5833 56.5833 43.7861 56.5833 28H55.4167ZM28 0.583333C43.1418 0.583333 55.4167 12.8582 55.4167 28H56.5833C56.5833 12.2139 43.7861 -0.583333 28 -0.583333V0.583333ZM28 -0.583333C12.2139 -0.583333 -0.583333 12.2139 -0.583333 28H0.583333C0.583333 12.8582 12.8582 0.583333 28 0.583333V-0.583333Z",
    fill: "#080808",
    fillOpacity: 0.08
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZec);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ZEC.42963ab3da209e5f97df994f179fceeb.svg";